export default __webpack_public_path__ + "static/media/header-back.5d6f6886.jpg";